import { render, staticRenderFns } from "./systemNotice.vue?vue&type=template&id=f43c9140&"
import script from "./systemNotice.vue?vue&type=script&lang=js&"
export * from "./systemNotice.vue?vue&type=script&lang=js&"
import style0 from "./systemNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports